module.exports = __webpack_public_path__ + "img/dzblgl1.0b6b25b6.png";